export const COLOMBIA_CITIES = [
    "Bogotá", "Medellín", "Cali", "Barranquilla", "Cartagena", "Cúcuta", "Bucaramanga",
    "Pereira", "Ibagué", "Villavicencio", "Santa Marta", "Manizales", "Neiva", "Pasto",
    "Montería", "Valledupar", "Armenia", "Sincelejo", "Popayán", "Tunja", "Riohacha",
    "Florencia", "Quibdó", "Yopal", "Arauca", "Mocoa", "San José del Guaviare",
    "Puerto Carreño", "Mitú", "Leticia", "Soacha", "Bello", "Envigado", "Itagüí",
    "Rionegro", "Palmira", "Buenaventura", "Tuluá", "Dosquebradas", "Soledad",
    "Otra ciudad",
];
